import { z } from "zod";
import { extendZodWithOpenApi } from "zod-openapi";
import { jsonBody, successResponse, tagPaths } from "../util.ts";
import { DisplayCurrency } from "./config.ts";

extendZodWithOpenApi(z);

//#region Tracking
export const GoogleTagManagerKey = z
    .object({
        gtm_key: z.string().describe("Google Tag Manager container ID injected into the UI."),
    })
    .openapi({ ref: "GoogleTagManagerKey" });

const DisplayCurrencies = z.array(DisplayCurrency).openapi({ ref: "DisplayCurrencies" });
//#endregion

export const trackingPaths = tagPaths("admin_tracking")({
    "/config/ui/gtm_key": {
        get: {
            summary: "Get Google Tag Manager key",
            responses: { ...successResponse(GoogleTagManagerKey) },
        },
        put: {
            summary: "Update Google Tag Manager key",
            requestBody: jsonBody(GoogleTagManagerKey),
            responses: { ...successResponse(GoogleTagManagerKey) },
        },
    },
    "/config/ui/currencies": {
        get: {
            summary: "Get display currencies",
            description:
                "Returns the display currencies configured for the UI. The site base currency is always included with an exchange rate of `1`.",
            responses: { ...successResponse(DisplayCurrencies) },
        },
        put: {
            summary: "Update display currencies",
            description:
                "Updates the alternative display currencies and their exchange rates relative to the site base currency. These currencies are used in the UI and by payment methods that settle in currencies other than the base currency.",
            requestBody: jsonBody(DisplayCurrencies),
            responses: { ...successResponse(DisplayCurrencies) },
        },
    },
});
